const innerW = window.innerWidth;
const isMobile = innerW < 768;
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    btnScroll();
    const navItems = initDom();
    domChange(navItems);
    bindAnchorScroll(navItems);
    const throttleSetActive = throttle(() => setActive(navItems), 500);
    const throttleBtnScroll = throttle(btnScroll, 200); // 为 btnScroll 添加节流，200ms
    window.addEventListener('scroll', () => {
      if (navItems && navItems.length > 0) {
        throttleBtnScroll();
        throttleSetActive();
      }
    });
  }, 1000);
});
// 监听dom出现,执行initDom
function domChange(navItems) {
  const targetNode = document.querySelector('#MainContent');
  let observer = null;
  if (targetNode) {
    let selectors = [], str = ''; //selectors保存需要监听的class
    navItems.forEach((item, index) => {
      const targetClass = item.dataset.target;
      str += (str ? ',' : '') + targetClass;
      selectors = str.split(',');
    });
    const debouncedInitDom = debounce(() => initDom(), 200);
    observer = new MutationObserver((mutationsList, observer) => {
      const found = selectors.some(selector => targetNode.querySelector(selector));
      if (found) {
        debouncedInitDom();
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
    });
    // 最多监听10秒(为什么不比对是否都出现就不监听了？因为有些元素可能是在某些主题下才有的，可能导致永不出现)
    setTimeout(() => {
      observer.disconnect();
      observer = null;
    }, 10000);
  } else {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    console.warn('#MainContent 未找到');
  }

}
/**
 * 初始化dom，保留有效dom
 * @returns {NodeListOf<Element>}
 */
function initDom() {
  const navItems = document.querySelectorAll('.anchor-bar .text');
  navItems.forEach((item, index) => {
    const targetClass = item.dataset.target;
    const targets = document.querySelectorAll(targetClass) || [];
    let hasDom = false;//是否有可显示的dom
    targets.forEach(target => {
      if (!isHidden(target)) {//没有被隐藏
        hasDom = true;
      }
    });
    if (hasDom) {
      //navItems[index] 的父元素li添加.hidden的css
      navItems[index].parentElement.classList.remove('hidden');
    } else {
      navItems[index].parentElement.classList.add('hidden');
    }
  });
  const anchorBar = document.querySelector('.anchor-bar');
  if (!anchorBar) { return navItems }
  if (navItems.length === 0) {
    anchorBar.classList.add('hidden');
  } else {
    anchorBar.classList.remove('hidden');
  }
  return navItems
}
/**
 * 锚点显示与否修改
 */
function btnScroll() {
  const addToCart = document.querySelector('.add-to-card-preorde-btn');
  let rect = addToCart.getBoundingClientRect();
  let distanceFromTop = rect.top;
  if (distanceFromTop < 0) {
    if (isMobile) {
      this.anchorBarScroll('translateY(0)');
    } else {
      this.anchorBarScrollPC('translateY(0)');
    }
  } else {
    if (isMobile) {
      this.anchorBarScroll('translateY(-100%)');
    } else {
      this.anchorBarScrollPC('translateY(100%)');
    }
  }
}
/**
 * 移动端锚点
 * @param {string} val 
 * @returns 
 */
function anchorBarScroll(val) {
  const anchorBar = document.querySelector('.anchor-bar');
  if (!anchorBar) { return }
  const zdaddtocart = document.querySelector('.add-to-card-preorder2');
  anchorBar.style.transform = val;
  if (val === 'translateY(-100%)') {
    zdaddtocart.style.transform = 'translateY(200%)';
    zdaddtocart.style.animation = 'none';
    anchorBar.style.top = 0;
    return
  }
  zdaddtocart.style.transform = 'translateY(0)';
  const header = document.querySelector('#shopify-section-header');
  const headerRect = header.getBoundingClientRect();
  const headerHeight = (headerRect.height + headerRect.top);
  const tops = headerHeight < 0 ? 0 : headerHeight;
  anchorBar.style.top = tops + 'px';
}
/**
 * pc端锚点
 * @param {string} val 
 * @returns 
 */
function anchorBarScrollPC(val) {
  const anchorBar = document.querySelector('.anchor-bar');
  if (!anchorBar) { return }
  const anchorBarBox = document.querySelector('.add-btn-box');
  anchorBar.style.transform = 'translateY(0)';
  anchorBarBox.style.transform = val;
  anchorBarBox.style.bottom = 0;
}
function bindAnchorScroll(navItems) {
  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      // 去掉之前的active，给当前点击的元素添加 active 类名
      const targetClass = item.dataset.target;
      const targets = document.querySelectorAll(targetClass) || [];
      targets.forEach((target) => {
        if (!isHidden(target)) {
          const targetTop = target.getBoundingClientRect().top;
          const anchorBar = document.querySelector('.anchor-bar') || {};
          const isMobile = innerW < 768;
          const anchorBarLocal = isMobile ? ((anchorBar.getBoundingClientRect().height || 0) + (anchorBar.getBoundingClientRect().top || 0)) : 0;
          const top = targetTop + window.scrollY - anchorBarLocal;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      });
      const setCss = () => {
        navItems.forEach(nav => nav.classList.remove('active'));
        item.classList.add('active');
      }
      setTimeout(() => {
        setCss()
      }, 400);
      setTimeout(() => {
        setCss()
      }, 700);
    });
  });
}
/**
 * 更新锚点
 */
function setActive(navItems) {
  let currentIndex = -1;
  navItems.forEach((item, index) => {
    const targetClass = item.dataset.target;
    const targets = document.querySelectorAll(targetClass) || [];

    targets.forEach(target => {
      if (!isHidden(target)) {
        const targetTop = target.getBoundingClientRect().top;
        const anchorBar = document.querySelector('.anchor-bar') || {};
        const anchorBarLocal = isMobile ? ((anchorBar.getBoundingClientRect().height || 0) + (anchorBar.getBoundingClientRect().top || 0)) : 0;
        if (targetTop - anchorBarLocal <= 10) {  // 进入视口上方
          currentIndex = index;
        }
      }
    });
  });

  // 更新高亮
  navItems.forEach(nav => nav.classList.remove('active'));
  if (currentIndex !== -1) {
    navItems[currentIndex].classList.add('active');
  }
}

/**
 * 检查元素是否被隐藏了
 */
function isHidden(element) {
  if (!element) return true; // 元素本身都没找到，视为隐藏
  if (getComputedStyle(element).display === 'none') return true; // 自己被隐藏
  if (element.parentElement) {
    return isHidden(element.parentElement); // 递归检查父级
  }
  return false; // 没有被隐藏
}